import '@patsnap-ui/icon/assets/solid/FolderMany.svg'
import { trackingEvent } from '@pharmsnap/shared/src/features/tracking'
import { defineComponent, PropType, ref } from '@vue/composition-api'
import { Icon as PtIcon } from 'patsnap-biz'
import { GTooltip } from '../../../..'
import { BSavedSearchDialog } from '../../../BSavedSearchDialog/BSavedSearchDialog'
import cn from '../../locales/cn.json'
import en from '../../locales/en.json'
import jp from '../../locales/jp.json'
import $class from './BSaveSearchButton.module.scss'

export const BSaveSearchButton = defineComponent({
  name: 'BSaveSearchButton',
  i18n: {
    messages: { cn, en, jp },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    queryId: {
      type: String as PropType<string | undefined>,
    },
    queryText: {
      type: String,
    },
    filterText: {
      type: String,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: 20,
    },
  },
  setup(props, ctx) {
    const dialogVisible = ref(false)
    function onShowDialog(e?: Event) {
      e?.stopPropagation()
      if (props.disabled || !props.queryId) return
      trackingEvent('CLICK_SAVE_QUERY_ENTRY', {
        trigger_point: ctx.root.$route.name || '',
        payload: {
          queryText: props.queryText,
          filterText: props.filterText,
          queryId: props.queryId,
        },
      })
      dialogVisible.value = true
    }

    return {
      dialogVisible,
      onShowDialog,
    }
  },
  render() {
    const disabled = this.disabled || !this.queryId
    const buttonText = this.buttonText || this.$tc('commonList.saveSearch')

    return (
      <div class={$class.container}>
        <GTooltip content={buttonText} placement="top" disabled={this.showText}>
          <div
            class={[$class.button, disabled ? $class.disabled : '']}
            title={buttonText}
            aria-label={buttonText}
            onClick={this.onShowDialog}
            data-testid="b-save-search-button"
          >
            <PtIcon
              icon="SolidFolderMany"
              class={disabled ? 'text-gray-55' : 'text-gray-450'}
              style={{
                width: `${this.iconSize}px`,
                height: `${this.iconSize}px`,
              }}
            ></PtIcon>
            {this.showText ? <span class={[$class.title, disabled ? 'text-gray-55' : 'text-text-default']}>{buttonText}</span> : null}
          </div>
        </GTooltip>
        <BSavedSearchDialog
          visible={this.dialogVisible}
          queryId={this.queryId}
          queryText={this.queryText}
          filterText={this.filterText}
          onInput={(visible: boolean) => {
            this.dialogVisible = visible
          }}
        ></BSavedSearchDialog>
      </div>
    )
  },
})
